export const MEDIA_UPLOAD = ['image/jpg', 'image/jpeg', 'image/png']
